import { ConflictOverride } from "../../components/modal/ConflictOverride";
import type { MoveMode } from "../../hooks/useMoveMode";
import css from "./MoveModeHud.module.css";

/**
 * MoveModeHud — баннер move-режима ОСНОВНОЙ сетки DC (A48-коррекция 13.08:
 * никакого отдельного интерфейса — «Перенести» подсвечивает обычную сетку).
 * Sticky-полоска: кого переносим + подсказка + ОТМЕНА; даты/филиалы листаются
 * штатной шапкой. Тап по свободному слоту обрабатывает DcGridScreen
 * (mm.dropOnSlot); 409-конфликты рендерятся здесь же (ConflictOverride).
 */
export function MoveModeHud({ mm }: { mm: MoveMode }) {
  if (!mm.booking) return null;
  return (
    <>
      <div className={`${css.banner} ${mm.moving ? css.busy : ""}`} role="status">
        <span className={css.pulse} aria-hidden="true" />
        <span className={css.text}>{mm.moving ? "ПЕРЕНОСИМ…" : "ПЕРЕНОС"}</span>
        {!mm.moving ? (
          <button type="button" className={css.cancel} onClick={mm.cancel}>
            ОТМЕНА
          </button>
        ) : null}
      </div>
      {/* 13.08: PUT /move долгий — вуаль глотает тапы и показывает, что идёт работа. */}
      {mm.moving ? <div className={css.veil} aria-hidden="true" /> : null}
      {mm.gate.conflicts ? (
        <ConflictOverride
          conflicts={mm.gate.conflicts}
          actionLabel={mm.gate.actionLabel}
          onForce={() => void mm.forceRetry()}
          onDismiss={mm.gate.clear}
        />
      ) : null}
    </>
  );
}
